import type { InvestmentActions, InvestmentState } from "./types";

const INITIAL_STATE: InvestmentState = {
  loading: false,
  data: [],
  refreshing: false,
  error: false,
};

export default (
  state: InvestmentState = INITIAL_STATE,
  action: InvestmentActions
): InvestmentState => {
  switch (action.type) {
    case "FECTH_INVESTMENT_DATA": {
      return {
        ...state,
        loading: true,
        error: false,
        refreshing: false,
      };
    }
    case "FETCH_INVESTEMENT_DATA_SUCCESS": {
      return {
        loading: false,
        error: false,
        refreshing: false,
        data: action.payload,
      };
    }
    case "FETCH_INVESTEMENT_DATA_FAILED": {
      return {
        ...state,
        loading: false,
        refreshing: false,
        error: true,
      };
    }
    default:
      return state;
  }
};
